// extracted by mini-css-extract-plugin
export default {"container":"components-Header-components-AuthBlock-authBlock-module__container--_j3bI","balance":"components-Header-components-AuthBlock-authBlock-module__balance--nJGES"};